import { all, call, put, takeLatest } from 'redux-saga/effects';
import { formatDateTimeUTC } from 'util/formatting';

import {
  endShiftFailure,
  endShiftRequest,
  endShiftSuccess,
  shiftsFailure,
  shiftsRequest,
  shiftsSuccess,
} from './actions';

import axios from 'axios';
import { SHIFTS, SHIFTS_V2 } from 'app/api-routes';
import { shiftStatsSaga } from 'ducks/shiftInfo/sagas';
import { SERVER_DATE_TIME_FORMAT } from 'app/types/constants';

function* shiftsSaga({ payload: { startDate, endDate, clientID, siteID, userID, supervisorID } }) {
  let fromDate, toDate;
  if (startDate != null && endDate != null) {
    fromDate = formatDateTimeUTC(startDate, SERVER_DATE_TIME_FORMAT);
    toDate = formatDateTimeUTC(endDate, SERVER_DATE_TIME_FORMAT);
  }

  try {
    const { payload } = yield axios.get(SHIFTS_V2, {
      params: {
        fromDate,
        toDate,
        clientID: clientID || null,
        siteID: siteID || null,
        userID: userID || null,
        supervisorID: supervisorID || null,
      },
    });

    yield put(shiftsSuccess(payload));
  } catch (err) {
    yield put(shiftsFailure(err));
  }
}

function* endShiftSaga({ payload: { shiftID, reasonID } }) {
  try {
    yield axios.delete(`${SHIFTS}/${shiftID}`, { params: { reasonID } });
    yield put(endShiftSuccess(shiftID));
    yield call(shiftStatsSaga, { payload: shiftID });
  } catch (err) {
    yield put(endShiftFailure(err));
  }
}

export default function* () {
  yield all([yield takeLatest(shiftsRequest, shiftsSaga), yield takeLatest(endShiftRequest, endShiftSaga)]);
}
